import { ExportType } from 'modules/audiences/AudienceProvider';

export function isCustomExportSelected(export_type: ExportType = ExportType.OA_MATCH): boolean {
  return [ExportType.BIDSTREAM, ExportType.BIDSTREAM_PLUS].includes(export_type);
}
